'use strict';

/**
 * Competitions
 */
waApp.controllers.Competitions = {
	_addAndEdit: function() {
		$('#award-id').change(function(e) {
			e.preventDefault();
			let value = $(this).val();
			if (value === '') {
				$('#placing-id').hide();
				$('#placing-id').val('');
			} else {
				$('#placing-id').show();
			}
		});

		$('#award-id').select2({
			placeholder: 'Select an award',
			allowClear: true
		});
		$('#project-id').select2({
			placeholder: 'Select a project',
			allowClear: true
		});

		$('#award-id').trigger('change');
		$('#project-id').trigger('change');
	},
	add: function() {
		waUtils.inputLanguageToggle();
		waApp.controllers.Competitions._addAndEdit();
	},
	edit: function() {
		waUtils.inputLanguageToggle();
		waApp.controllers.Competitions._addAndEdit();
	}
};
